export const FETCH_ORGANISATION_USERS = 'user/FETCH_ORGANISATION_USERS';
export const FETCH_ORGANISATION_CLIENTS = 'user/FETCH_ORGANISATION_CLIENTS';
export const ADD_ORGANISATION_USER = 'user/ADD_ORGANISATION_USER';
export const DELETE_ORGANISATION_USER = 'user/DELETE_ORGANISATION_USER';
export const EDIT_ORGANISATION_USER = 'user/EDIT_ORGANISATION_USER';
export const FETCH_ROLES = 'user/FETCH_ROLES';
